export default __webpack_public_path__ + "static/phone1-88fb63003c8aec14f77a7d3c4a07b92b.jpg";